export default "be8ebb287c8f2c7d.svg"